import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography, Button } from '@mui/material'

/**
 * Component to display errors
 * @param {string} error - The error message
 * @param {function} onRetry - Optional callback to retry
 */
const WidgetError = ({ error, onRetry, t_ }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        p: 2,
        color: 'error.main'
      }}
    >
      <Typography variant='caption' align='center' gutterBottom>
        {error}
      </Typography>

      {onRetry && (
        <Button size='small' color='primary' onClick={onRetry}>
          {t_ ? t_('Retry') : 'Retry'}
        </Button>
      )}
    </Box>
  )
}

WidgetError.propTypes = {
  error: PropTypes.string,
  onRetry: PropTypes.func,
  t_: PropTypes.func
}

export default WidgetError
